// import { PlusCircleOutlined } from "@ant-design/icons";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Button,
//   Col,
//   Form,
//   Input,
//   Modal,
//   Row,
//   message,
//   Divider,
//   TreeSelect,
//   Spin,
//   Select,
// } from "antd";
// import React, { useState, useEffect } from "react";
// import { store } from "../../../redux/configStore";
// import {
//   getListZnsEvent,
//   createZnsEvent,
// } from "../../../api/znsEvent/znsEvent";

// export default function FormAddZnsEvent({
//   isModalOpen,
//   handleCancel,
//   currentPage,
//   pageSize,
// }) {
//   const [isLoadCreate, setIsLoadCreate] = useState(false);
//   const [formRef] = Form.useForm();
//   const dispatch = useDispatch();

//   // Xử lý khi nhấn nút "Thêm"
//   const onFinish = async (fieldsValue) => {
//     const values = { ...fieldsValue };
//     setIsLoadCreate(true);

//     try {
//       const response = await store.dispatch(createZnsEvent(values));
//       if (createZnsEvent.fulfilled.match(response)) {
//         if (response.payload.data.original) {
//           message.error(response.payload.data.original.message);
//         } else {
//           message.success("Thêm cơ chế thành công");
//           formRef.resetFields();
//           handleCancel();
//           await store.dispatch(
//             getListZnsEvent({ currentPage, pageSize })
//           );
//         }
//       } else if (createZnsEvent.rejected.match(response)) {
//         handleErrors(response);
//       }
//     } catch (error) {
//       message.error("Đã xảy ra lỗi khi tạo cơ chế.");
//     } finally {
//       setIsLoadCreate(false);
//     }
//   };

//   // Hàm xử lý lỗi từ API
//   const handleErrors = (response) => {
//     if (response.payload.errors) {
//       Object.keys(response.payload.errors).forEach((field) => {
//         const errorMessages = response.payload.errors[field];
//         errorMessages.forEach((errorMessage) => {
//           message.error(errorMessage);
//         });
//       });
//     } else if (response.payload.message) {
//       message.error(response.payload.message);
//     }
//   };


//   return (
//     <div>
//       <Modal
//         title="Thêm sự kiện"
//         open={isModalOpen}
//         footer={null}
//         onCancel={handleCancel}
//         width="70%"
//       >
//         <Form
//           name="addZnsEvent"
//           form={formRef}
//           onFinish={onFinish}
//           layout="vertical"
//           requiredMark=""
//         >

//           {/* Mã sự kiện */}
//           <Row>
//             <Col span={24}>
//               <Form.Item
//                 label="Mã sự kiện"
//                 name="code"
//                 rules={[
//                   { required: true, message: "Vui lòng nhập mã sự kiện" },
//                 ]}
//               >
//                 <Input placeholder="Nhập mã sự kiện" />
//               </Form.Item>
//             </Col>
//           </Row>

//           {/* Tên sự kiện*/}
//           <Row>
//             <Col span={24}>
//               <Form.Item
//                 label="Tên sự kiện"
//                 name="name"
//                 rules={[{ required: true }]}
//               >
//                 <Input placeholder="Nhập tên sự kiện" />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row>
//             <Col span={24}>
//               <Form.Item
//                 label="Alias"
//                 name="alias"
//                 rules={[{ required: true }]}
//               >
//                 <Input placeholder="Alias" />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Divider />

//           {/* Nút Thêm */}
//           <Row>
//             <Col span={24} style={{ textAlign: "center" }}>
//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 icon={<PlusCircleOutlined />}
//                 loading={isLoadCreate}
//                 style={{ minWidth: 150 }}
//               >
//                 Thêm mới
//               </Button>
//             </Col>
//           </Row>
//         </Form>
//       </Modal>
//     </div>
//   );
// }

import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  message,
  Divider,
  Space,
  Spin,
} from "antd";
import React, { useState, useCallback, useMemo } from "react";
import { store } from "../../../redux/configStore";
import {
  getListZnsEvent,
  createZnsEvent,
} from "../../../api/znsEvent/znsEvent";

export default function FormAddZnsEvent({
  isModalOpen,
  handleCancel,
  currentPage,
  pageSize,
}) {
  const [isLoadCreate, setIsLoadCreate] = useState(false);
  const [formRef] = Form.useForm();
  const dispatch = useDispatch();

  // Validation rules tương ứng với Laravel backend
  const validationRules = useMemo(() => ({
    code: [
      { required: true, message: "Vui lòng nhập mã sự kiện" },
      { max: 255, message: "Mã sự kiện không được vượt quá 255 ký tự" },
      {
        pattern: /^[a-zA-Z0-9_-]+$/,
        message: "Mã sự kiện chỉ được chứa chữ cái, số, dấu gạch ngang và dấu gạch dưới"
      }
    ],
    name: [
      { required: true, message: "Vui lòng nhập tên sự kiện" },
      { min: 2, message: "Tên sự kiện phải có ít nhất 2 ký tự" },
      { max: 500, message: "Tên sự kiện không được vượt quá 500 ký tự" }
    ],
    alias: [
      { type: 'string', message: "Alias phải là chuỗi ký tự" }
    ]
  }), []);

  // Xử lý submit form với validation nâng cao
  const onFinish = useCallback(async (fieldsValue) => {
    const values = { 
      ...fieldsValue,
      // Xử lý alias thành array các string: [bien1, bien2]
      alias: fieldsValue.alias?.filter(item => item?.trim()) || []
    };

    setIsLoadCreate(true);

    try {
      const response = await store.dispatch(createZnsEvent(values));
      
      if (createZnsEvent.fulfilled.match(response)) {
        const { data } = response.payload;
        
        if (data.original?.message) {
          message.error(data.original.message);
        } else {
          message.success("Thêm sự kiện thành công");
          formRef.resetFields();
          handleCancel();
          // Refresh danh sách
          await store.dispatch(getListZnsEvent({ currentPage, pageSize }));
        }
      } else if (createZnsEvent.rejected.match(response)) {
        handleErrors(response);
      }
    } catch (error) {
      console.error("Error creating ZNS event:", error);
      message.error("Đã xảy ra lỗi khi tạo sự kiện. Vui lòng thử lại.");
    } finally {
      setIsLoadCreate(false);
    }
  }, [currentPage, pageSize, handleCancel, formRef]);

  // Xử lý lỗi validation từ backend
  const handleErrors = useCallback((response) => {
    const { payload } = response;
    
    if (payload?.errors) {
      // Xử lý lỗi validation từ Laravel
      const errorFields = [];
      
      Object.entries(payload.errors).forEach(([field, messages]) => {
        const fieldMessages = Array.isArray(messages) ? messages : [messages];
        
        // Set lỗi cho form field
        errorFields.push({
          name: field,
          errors: fieldMessages
        });
        
        // Hiển thị message
        fieldMessages.forEach(msg => message.error(msg));
      });
      
      // Set lỗi cho form
      formRef.setFields(errorFields);
    } else if (payload?.message) {
      message.error(payload.message);
    } else {
      message.error("Đã xảy ra lỗi không xác định");
    }
  }, [formRef]);

  // Reset form khi đóng modal
  const handleModalCancel = useCallback(() => {
    formRef.resetFields();
    handleCancel();
  }, [formRef, handleCancel]);

  // Validator tùy chỉnh cho mã sự kiện
  const validateCode = useCallback(async (_, value) => {
    if (!value) return Promise.resolve();
    
    // Kiểm tra độ dài
    if (value.length > 255) {
      return Promise.reject(new Error("Mã sự kiện không được vượt quá 255 ký tự"));
    }
    
    // Kiểm tra format
    if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
      return Promise.reject(new Error("Mã sự kiện chỉ được chứa chữ cái, số, dấu gạch ngang và dấu gạch dưới"));
    }
    
    return Promise.resolve();
  }, []);

  return (
    <Modal
      title="Thêm sự kiện ZNS"
      open={isModalOpen}
      footer={null}
      onCancel={handleModalCancel}
      width="70%"
      destroyOnClose
      maskClosable={false}
    >
      <Spin spinning={isLoadCreate}>
        <Form
          name="addZnsEvent"
          form={formRef}
          onFinish={onFinish}
          layout="vertical"
          requiredMark={false}
          scrollToFirstError
          preserve={false}
        >
          {/* Mã sự kiện */}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Mã sự kiện"
                name="code"
                rules={[
                  { required: true, message: "Vui lòng nhập mã sự kiện" },
                  { validator: validateCode }
                ]}
                hasFeedback
              >
                <Input 
                  placeholder="Nhập mã sự kiện (chỉ chứa chữ cái, số, _, -)" 
                  maxLength={255}
                  showCount
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Tên sự kiện */}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Tên sự kiện"
                name="name"
                rules={validationRules.name}
                hasFeedback
              >
                <Input 
                  placeholder="Nhập tên sự kiện" 
                  maxLength={500}
                  showCount
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Alias - Dynamic Fields */}
          <Row gutter={16}>
            <Col span={24}>
              <Form.List name="alias">
                {(fields, { add, remove }) => (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <label style={{ fontWeight: 500 }}>Alias</label>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        icon={<PlusCircleOutlined />}
                        style={{ marginLeft: 8 }}
                        size="small"
                      >
                        Thêm alias
                      </Button>
                    </div>
                    
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{ display: 'flex', marginBottom: 8, width: '100%' }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={name}
                          rules={[
                            { type: 'string', message: "Alias phải là chuỗi ký tự" },
                            { max: 255, message: "Alias không được vượt quá 255 ký tự" },
                            { required: true, message: "Vui lòng nhập alias" }
                          ]}
                          style={{ flex: 1, marginBottom: 0 }}
                        >
                          <Input 
                            placeholder="Nhập alias (vd: bien1)" 
                            maxLength={255}
                          />
                        </Form.Item>
                        
                        <Button
                          type="text"
                          danger
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                          size="small"
                        />
                      </Space>
                    ))}
                    
                    {fields.length === 0 && (
                      <Form.Item style={{ marginBottom: 0 }}>
                        <Input.TextArea
                          placeholder="Chưa có alias nào. Nhấn 'Thêm alias' để thêm mới."
                          disabled
                          rows={2}
                          style={{ backgroundColor: '#f5f5f5' }}
                        />
                      </Form.Item>
                    )}
                  </>
                )}
              </Form.List>
            </Col>
          </Row>

          <Divider />

          {/* Actions */}
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Space>
                <Button onClick={handleModalCancel}>
                  Hủy
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<PlusCircleOutlined />}
                  loading={isLoadCreate}
                  style={{ minWidth: 150 }}
                >
                  Thêm mới
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
}